import { ChangeAction } from 'types/services/redux-action';
import { FetchReducer } from 'types/services/redux-state';

export const RESEND_VERIFICATION_EMAIL = 'RESEND_VERIFICATION_EMAIL';

export const RESEND_VERIFICATION_EMAIL_IS_PENDING = 'RESEND_VERIFICATION_EMAIL_IS_PENDING';

export const RESEND_VERIFICATION_EMAIL_IS_ERROR = 'RESEND_VERIFICATION_EMAIL_IS_ERROR';

export type ResendVerificationEmailReducerState = FetchReducer<'resendVerificationEmail'>;

export type ResendVerificationEmailActions = ChangeAction<'RESEND_VERIFICATION_EMAIL'>;
